<script setup>
import useGrid from "@/composables/useGrid";
import TablePager from "@/components/TablePager.vue";
import StartupsHeader from "@/components/ecosystem/StartupsHeader.vue";
import VClamp from "vue-clamp";
import EditPortfolio from "@/components/portfolios/EditPortfolio.vue";
import SharePortfolio from "@/components/portfolios/SharePortfolio.vue";
import portfoliosService from "@/services/ecosystem/portfolios.service";
import {onMounted, ref} from "vue";
import portfolios from "@/services/ecosystem/portfolios.service";

const {gridParams, gridMethods, items} = useGrid(getList, 25);

const editPortfolio = ref(null);
const sharePortfolio = ref(null);

onMounted(() => {
    gridMethods.loadIfNotLoaded();
});

function getList(pageParams) {
    return portfoliosService.getPortfolios(pageParams);
}

function applySearch(term) {
    gridParams.filters.name = term.toLowerCase();
    gridMethods.resetList();
}

async function deletePortfolio(id) {
    if (confirm("Remove portfolio?")) {
        await portfolios.deletePortfolio(id)
        gridMethods.resetList();
    }
}
</script>

<template>
    <div class="mystartups-page">
        <header class="topbar mystartups-page__header">
            <StartupsHeader/>

            <input
                type="text"
                class="form-search-primary"
                placeholder="Search Portfolios"
                v-debounce:500ms.lock="applySearch"
            >
            <div class="topbar__side actions-list">
                <a class="link-wrapper ml-4" @click="editPortfolio.open()"><span class="link-wrapper__add" >New Portfolio</span></a>
            </div>
        </header>

        <main class="main main--dark">
            <div class="main__inner">
                <div class="showing-select">
                    Showing

                    <select
                        v-if="gridParams.totalRowsCount >= 25"
                        v-model="gridParams.pageLength"
                    >
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                    </select>
                    <template v-else>
                        {{gridParams.totalRowsCount}}
                    </template>

                    of {{gridParams.totalRowsCount}} portfolios
                </div>

                <ul class="list-cards">
                    <li v-for="portfolio in items" :key="portfolio.id">
                        <div class="list-cards__content">
                            <div>
                                <router-link
                                    class="heading5 heading5--tertiary"
                                    v-for="name in portfolio.name"
                                    :to="name.to"
                                    :key="name.to"
                                >
                                    {{ name.label }}
                                </router-link>
                                <p>
                                    <v-clamp autoresize :max-lines="3">
                                        {{ portfolio.description }}
                                        <template #after="{ toggle, expanded, clamped }">
                                            <a v-if="expanded" class="link" @click="toggle"> Less</a>
                                            <a v-if="clamped" class="link" @click="toggle"> More</a>
                                        </template>
                                    </v-clamp>
                                </p>
                            </div>
                            <div>
                                <span class="portfolio-startups">{{ portfolio.startups_count ? portfolio.startups_count : 0 }} startups</span>
                                <span class="portfolio-enterprises">{{ portfolio.enterprises_count ? portfolio.enterprises_count : 0 }} enterprise shared</span>
                            </div>
                        </div>
                        <b-dropdown right text="Actions" class="list-cards__actions icons-list dropdown-simple dropdown-small ml-auto">
                            <b-dropdown-item @click="editPortfolio.open(portfolio.id)" class="icons-list__edit">Edit </b-dropdown-item>
                            <b-dropdown-item @click="sharePortfolio.open(portfolio.id)" class="icons-list__share">Share</b-dropdown-item>
                            <b-dropdown-item @click="deletePortfolio(portfolio.id)" class="icons-list__delete">Delete</b-dropdown-item>
                        </b-dropdown>
                    </li>
                </ul>

                <TablePager
                    v-if="items.length"
                    :pages-count="gridParams.pagesCount"
                    :init-page="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                />
            </div>
        </main>

        <EditPortfolio
            ref="editPortfolio"
            @saved="gridMethods.resetList"
        />

        <SharePortfolio
            ref="sharePortfolio"
            @saved="gridMethods.resetList"
        />
    </div>
</template>

<style scoped>

</style>
